import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'loadingButton',
    templateUrl: './loadingbutton.component.html',
    styleUrls: ['./loadingbutton.component.scss']
})
export class LoadingbuttonComponent implements OnInit {

    @Input() loading: boolean;
    @Input() disabled: boolean;
    @Input() text: string;
    @Input() color: string;
    @Input() icon: string;
    @Input() inprogressMessage: string;
    @Output() public buttonPressed = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }

    save() {
        this.buttonPressed.emit();
    }
}


